import {
	MatterFileType,
	MatterSource,
	MatterUndertakingOverview,
} from '../db-models/matter';

export interface fnCallable {
	getOutstandingUndertakings: string;
}

export const fnCallable: fnCallable = {
	getOutstandingUndertakings: 'undertaking_getOutstanding',
};

export interface GetOutstandingUndertakingsRequest {
	filterProperty: string;
	filterValue: string;
	businessId: string;
}

export interface OutstandingUndertakingsResponse {
	id: string;
	lawyerId: string;
	clerkId: string;
	name: string;
	fileType: MatterFileType;
	number: string;
	closingDate: string;
	undertakings: MatterUndertakingOverview;
	matterSource: MatterSource;
}
